import { ChangePasswordForm } from '@/components/ChangePasswordForm';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/Card';

export function AdminSettings() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Security Settings</CardTitle>
        <CardDescription>
          Manage your account security and privacy settings
        </CardDescription>
      </CardHeader>

      <CardContent className="space-y-6">
        <ChangePasswordForm />
      </CardContent>
    </Card>
  );
}
